import * as yup from 'yup'

export const getValidationErrors =
  <ErrorType>() =>
  async <T extends object>({
    schema,
    data,
  }: {
    schema: yup.ObjectSchema<T>
    data: T
  }): Promise<Partial<Record<keyof T, ErrorType>>> => {
    try {
      await schema.validate(data, { abortEarly: false })
      return {}
    } catch (err) {
      const errors: Partial<Record<keyof T, ErrorType>> = {}
      if (err instanceof yup.ValidationError) {
        err.inner.forEach(error => {
          if (error.path && error.path in data) {
            errors[error.path as keyof T] = error.message as ErrorType
          }
        })
      }
      return errors
    }
  }
